// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"0c989746","42":"d9f90099","43":"3727b762","63":"a9a2eb7f","130":"8aa48ff1","789":"df0608c7","892":"cbc10e4b","899":"9e54f847","950":"85e6fb73"}[chunkId] + ".chunk.js";
};